import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { toShortCode } from "./useLanguage.js";

const OG_LOCALE = { en: "en_US", el: "el_GR" };

const upsertMeta = (selector, attr, name, content) => {
  let tag = document.querySelector(selector);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
};

export default function useDocumentMeta({
  titleKey,
  descriptionKey,
  descriptionContext,
} = {}) {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const lang = toShortCode(i18n.resolvedLanguage || i18n.language);
    document.documentElement.lang = lang;

    const descriptionOpts = descriptionContext ? { context: descriptionContext } : undefined;
    const title =
      titleKey && t(titleKey) !== titleKey ? t(titleKey) : null;
    const description =
      descriptionKey && t(descriptionKey, descriptionOpts) !== descriptionKey
        ? t(descriptionKey, descriptionOpts)
        : null;

    if (title) {
      document.title = title;
      upsertMeta('meta[property="og:title"]', "property", "og:title", title);
      upsertMeta(
        'meta[property="twitter:title"]',
        "property",
        "twitter:title",
        title,
      );
    }

    if (description) {
      upsertMeta(
        'meta[name="description"]',
        "name",
        "description",
        description,
      );
      upsertMeta(
        'meta[property="og:description"]',
        "property",
        "og:description",
        description,
      );
      upsertMeta(
        'meta[property="twitter:description"]',
        "property",
        "twitter:description",
        description,
      );
    }

    upsertMeta(
      'meta[property="og:locale"]',
      "property",
      "og:locale",
      OG_LOCALE[lang] || OG_LOCALE.en,
    );
  }, [t, i18n.resolvedLanguage, i18n.language, titleKey, descriptionKey, descriptionContext]);
}
